<!--
 * File: Home.vue
 * Project: timo
 * File Created: Monday, 21st September 2020 5:35:19 pm
 * Author: Timo Zacherl
 * License: MPL-2.0
 * 
 * -----
 * Last Modified: Monday, 21st September 2020 7:28:32 pm
 * Modified By: Timo Zacherl
 * -----
 * 
 * Copyright © 2020 Timo Zacherl. All rights reserved.
-->

<template>
  <div class="home">
    <div class="container">
      <AppCard appIcon="Gitimoji512@2x" routerLink="/gitimoji" class="is-big" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AppCard from "@/components/AppCard";

export default {
  name: "Home",
  components: {
    AppCard
  }
};
</script>

<style lang="scss" scoped></style>
